import axios from './../http'

function query(data) {
    return axios.post('/sys/token/query', data);
}
function del(data) {
    return axios.post('/sys/token/del', data);
}
export default {
    query,
    del
}